/* Charley Wand page: replaces the PageFly runtime for this page only.
   Covers slideshows, product media gallery, accordion, quantity, add-to-cart and scroll-to-section buttons.
   Add to cart is an inline cart-permalink handler in the section (Shopify checkout, no Onward Checkout+). */
(function () {
  var root = document.querySelector('.__pf');
  if (!root) return;
  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('cw-config').textContent) || {}; } catch (e) {}

  function el(tag, cls, attrs) {
    var e = document.createElement(tag); if (cls) e.className = cls;
    for (var k in attrs || {}) e.setAttribute(k, attrs[k]);
    return e;
  }
  function settingsFor(node) {
    var m = (node.className || '').match(/pf-\d+_/); return (m && cfg[m[0]]) || {};
  }
  function bp() {
    var w = window.innerWidth;
    return w >= 1025 ? 'all' : w >= 992 ? 'laptop' : w >= 768 ? 'tablet' : 'mobile';
  }

  function findOrMake(scope, parent, cls, label, navStyle) {
    var b = scope.querySelector('.' + cls);
    if (!b) { b = el('button', cls + ' ' + navStyle + (navStyle === 'none' ? ' hide' : ''), { type: 'button', 'aria-label': label }); parent.appendChild(b); }
    return b;
  }

  /* Generic scroll-snap carousel: track holds slides, prev/next step one slide, dots per start position. */
  function carousel(track, slidesSel, opts) {
    var slides = [].slice.call(track.querySelectorAll(slidesSel));
    if (!slides.length) return null;
    function perView() {
      var first = slides[0].getBoundingClientRect().width || 1;
      return Math.max(1, Math.round(track.clientWidth / first));
    }
    function maxIndex() { return Math.max(0, slides.length - perView()); }
    function current() {
      var x = track.scrollLeft, best = 0, d = Infinity;
      slides.forEach(function (s, i) { var dd = Math.abs(s.offsetLeft - track.offsetLeft - x); if (dd < d) { d = dd; best = i; } });
      return Math.min(best, maxIndex());
    }
    function go(i) {
      var max = maxIndex();
      if (opts.loop) i = i > max ? 0 : i < 0 ? max : i; else i = Math.max(0, Math.min(max, i));
      track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
    }
    var prev = opts.prev, next = opts.next, dotsWrap = opts.dots;
    function sync() {
      var i = current(), max = maxIndex();
      if (prev) prev.style.visibility = (!opts.loop && i <= 0) || max === 0 ? 'hidden' : 'visible';
      if (next) next.style.visibility = (!opts.loop && i >= max) || max === 0 ? 'hidden' : 'visible';
      if (dotsWrap) {
        if (dotsWrap.children.length !== max + 1) {
          dotsWrap.innerHTML = '';
          for (var n = 0; n <= max; n++) (function (n) {
            var b = el('button', '', { type: 'button', 'aria-label': 'Go to slide ' + (n + 1) });
            b.addEventListener('click', function () { go(n); restart(); }); dotsWrap.appendChild(b);
          })(n);
        }
        [].forEach.call(dotsWrap.children, function (b, n) { b.classList.toggle('active', n === i); });
      }
      if (opts.onChange) opts.onChange(i);
    }
    if (prev) prev.addEventListener('click', function () { go(current() - 1); restart(); });
    if (next) next.addEventListener('click', function () { go(current() + 1); restart(); });
    var t, timer;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 80); }, { passive: true });
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(sync, 150); });
    function restart() {
      if (!opts.autoPlay) return;
      clearInterval(timer);
      timer = setInterval(function () { if (document.visibilityState === 'visible') go(current() + 1); }, opts.autoPlayDelay || 3000);
    }
    sync(); restart();
    window.addEventListener('load', sync);
    if (window.ResizeObserver) new ResizeObserver(function () { clearTimeout(t); t = setTimeout(sync, 100); }).observe(track);
    return { go: go, current: current };
  }

  /* Slideshows */
  [].forEach.call(root.querySelectorAll('[data-cw-type="Slideshow"]'), function (box) {
    var s = settingsFor(box), track = box.querySelector('.pf-slider');
    if (!track) return;
    var navStyle = s.navStyle || 'none', pag = s.paginationStyle || 'none';
    // PageFly already server-renders the arrows and the dot row; reuse them, create only what is missing
    var prev = findOrMake(box, track, 'pf-slider-prev', 'Previous', navStyle);
    var next = findOrMake(box, track, 'pf-slider-next', 'Next', navStyle);
    var dots = null;
    if (pag !== 'none') {
      dots = box.querySelector('.pf-slider-nav');
      if (!dots) { dots = el('div', 'pf-slider-nav ' + pag); box.appendChild(dots); }
    }
    track.classList.add('has-loaded');
    carousel(track, '.pf-slide', {
      prev: navStyle === 'none' ? null : prev, next: navStyle === 'none' ? null : next, dots: dots,
      loop: !!s.loop, autoPlay: !!s.autoPlay, autoPlayDelay: s.autoPlayDelay
    });
    if (navStyle === 'none') { prev.style.visibility = next.style.visibility = 'hidden'; }
  });

  /* Product media: main image slider + thumbnail list */
  [].forEach.call(root.querySelectorAll('[data-cw-type="ProductMedia2"]'), function (pm) {
    var main = pm.querySelector('[data-cw-type="MediaMain"]');
    var track = main && main.querySelector('.pf-media-slider');
    if (!track) return;
    var s = settingsFor(main), navStyle = s.navStyle || 'none';
    var thumbs = [].slice.call(pm.querySelectorAll('.pf-slide-list-media'));
    var slides = [].slice.call(track.querySelectorAll('.pf-slide-main-media'));
    track.style.scrollSnapType = 'x mandatory';
    slides.forEach(function (sl) { sl.style.scrollSnapStop = 'always'; });
    var prev = null, next = null;
    if (navStyle !== 'none') {
      prev = findOrMake(track, track, 'pf-slider-prev', 'Previous', navStyle);
      next = findOrMake(track, track, 'pf-slider-next', 'Next', navStyle);
    }
    track.classList.add('has-loaded');
    var c = carousel(track, '.pf-slide-main-media', {
      prev: prev, next: next, loop: false,
      onChange: function (i) {
        slides.forEach(function (sl, n) { sl.classList.toggle('is-current', n === i); sl.setAttribute('data-active', n === i ? 'true' : 'false'); });
        var id = slides[i] && slides[i].getAttribute('data-media-id');
        thumbs.forEach(function (th) { th.setAttribute('data-active', th.getAttribute('data-img-id') === id ? 'true' : 'false'); });
      }
    });
    thumbs.forEach(function (th) {
      th.addEventListener('click', function () {
        var id = th.getAttribute('data-img-id');
        for (var n = 0; n < slides.length; n++) if (slides[n].getAttribute('data-media-id') === id) { c && c.go(n); break; }
      });
    });
  });

  /* Accordion (one open at a time unless data-multiple="true") */
  [].forEach.call(root.querySelectorAll('[data-cw-type="Accordion"]'), function (acc) {
    var multiple = acc.getAttribute('data-multiple') === 'true';
    var headers = [].slice.call(acc.querySelectorAll('[data-cw-type="Accordion.Header"]'));
    function body(h) { return acc.querySelector('[data-cw-type="Accordion.Content"][data-id="' + h.getAttribute('data-header-id') + '"]'); }
    function set(h, open) { h.setAttribute('data-active', open ? 'true' : 'false'); var b = body(h); if (b) b.style.display = open ? '' : 'none'; }
    headers.forEach(function (h) {
      set(h, h.getAttribute('data-active') === 'true');
      h.addEventListener('click', function () {
        var open = h.getAttribute('data-active') !== 'true';
        if (open && !multiple) headers.forEach(function (o) { if (o !== h) set(o, false); });
        set(h, open);
      });
    });
  });

  /* Quantity +/- and Add to cart are inline onclick handlers in the section (Shopify cart permalink to checkout,
     without Onward Checkout+), so they work before this deferred file loads. Only the initial minus state is set here. */
  [].forEach.call(root.querySelectorAll('[data-cw-type="ProductQuantity"]'), function (q) {
    var input = q.querySelector('input[name="quantity"]'), dec = q.querySelector('[data-quantity-action="decrease"]');
    if (input && dec) dec.disabled = (parseInt(input.value, 10) || 1) <= (parseInt(input.min, 10) || 1);
  });

  /* Buttons that scroll to a section (data-cw-to-section="pf-xxxx"). Missing targets do nothing, as on the original. */
  [].forEach.call(root.querySelectorAll('[data-cw-to-section]'), function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var target = root.querySelector('[data-section-id="' + a.getAttribute('data-cw-to-section') + '"]');
      if (!target) return;
      var off = 0; try { off = (JSON.parse(a.getAttribute('data-offset') || '{}')[bp()]) || 0; } catch (x) {}
      window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - off, behavior: 'smooth' });
    });
  });

  /* Elements with a click-through URL (logo) */
  [].forEach.call(root.querySelectorAll('[data-action="url"][data-href]'), function (n) {
    n.style.cursor = 'pointer';
    n.addEventListener('click', function () {
      var href = n.getAttribute('data-href'), tgt = n.getAttribute('data-target') || '_self';
      if (tgt === '_blank') window.open(href, '_blank', 'noopener'); else window.location.href = href;
    });
  });
})();
